class SideDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

    this.imageEl = this.dialog.querySelector('[data-drawer-image-el]');
    this.titleEl = this.dialog.querySelector('[data-drawer-title-el]');
    this.priceEl = this.dialog.querySelector('[data-drawer-price-el]');
    this.descEl = this.dialog.querySelector('[data-drawer-desc-el]');
    this.descSectionEl = this.dialog.querySelector('[data-drawer-desc-section]');
    this.insideSectionEl = this.dialog.querySelector('[data-drawer-inside-section]');
    this.insideLabelEl = this.dialog.querySelector('[data-drawer-inside-label-el]');
    this.insideListEl = this.dialog.querySelector('[data-drawer-inside-el]');
    this.closeBtn = this.dialog.querySelector('[data-drawer-close]');
    this.lastTrigger = null;

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-drawer-open]');
      if (!trigger) return;
      e.preventDefault();
      this.open(trigger);
    });

    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());

    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) this.close();
    });

    this.dialog.addEventListener('close', () => {
      if (this.lastTrigger && typeof this.lastTrigger.focus === 'function') this.lastTrigger.focus();
      this.lastTrigger = null;
    });
  }

  open(trigger) {
    const item = trigger.closest('[data-drawer-item]');
    if (!item) return;

    const image = item.dataset.drawerImage || '';
    this.imageEl.src = image;
    this.imageEl.alt = item.dataset.drawerTitle || '';
    this.imageEl.closest('.side-drawer__media').style.display = image ? '' : 'none';

    this.titleEl.textContent = item.dataset.drawerTitle || '';

    const price = item.dataset.drawerPrice || '';
    const comparePrice = item.dataset.drawerComparePrice || '';
    this.priceEl.innerHTML = '';
    if (comparePrice) {
      const was = document.createElement('span');
      was.className = 'side-drawer__price-was';
      was.textContent = comparePrice;
      this.priceEl.appendChild(was);
    }
    if (price) {
      const now = document.createElement('span');
      now.className = 'side-drawer__price-now';
      now.textContent = price;
      this.priceEl.appendChild(now);
    }
    this.priceEl.style.display = price ? '' : 'none';

    const descriptionHtml = item.dataset.drawerDescription || '';
    this.descEl.innerHTML = descriptionHtml;
    if (this.descSectionEl) this.descSectionEl.style.display = descriptionHtml ? '' : 'none';

    const insideHtml = item.dataset.drawerInside || '';
    if (this.insideLabelEl) this.insideLabelEl.textContent = item.dataset.drawerInsideLabel || "What's inside";
    if (this.insideListEl) this.insideListEl.innerHTML = insideHtml;
    if (this.insideSectionEl) this.insideSectionEl.style.display = insideHtml ? '' : 'none';

    this.lastTrigger = trigger;
    if (!this.dialog.open) this.dialog.showModal();
    if (this.closeBtn) this.closeBtn.focus();
  }

  close() {
    if (this.dialog.open) this.dialog.close();
  }
}

customElements.define('side-drawer', SideDrawer);
